import * as Yup from "yup";
import { tr } from "yup-locales";
if (process.env.NEXT_PUBLIC_LANGUAGE !== "en") Yup.setLocale(tr); // en: Yup varsayilan (Ingilizce) mesajlari

export const InvoiceSheme = Yup.object().shape({
  faturatipi: Yup.number().required(),
  isim: Yup.string().required(),
  tcno: Yup.number().required(),
  email: Yup.string().required().email(),
  telefonIsValid: Yup.boolean().isTrue(),
});
